import type { FunctionComponent } from 'react';
import type { TypeDataListProps } from './types';

/**
 * DataList permite crear un listado de datos
 */
export const DataList: FunctionComponent<TypeDataListProps> = ({
  className = '',
  children,
}: TypeDataListProps) => (
  <div className={`[&>*:not(:last-of-type)]:mb-6 ${className}`}>{children}</div>
);
